import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { authAPI } from '../services/api';
import { useNotify } from '../context/NotifyContext';
import GradientSpinner from '../components/GradientSpinner';
import '../App.css';

const LAB_LOGO_KEY = 'labLogoUrl';

const ForgotPassword = () => {
  const { showSuccess, showError } = useNotify();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [labLogoUrl, setLabLogoUrl] = useState(null);

  useEffect(() => {
    setLabLogoUrl(localStorage.getItem(LAB_LOGO_KEY));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await authAPI.forgotPassword({ email: email.trim() });
      showSuccess(data?.message || 'Check your email for next steps.');
      setEmail('');
    } catch (err) {
      showError(err.response?.data?.message || 'Something went wrong. Try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="App" style={{ height: '100vh', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div
        className="container"
        style={{
          maxWidth: '500px',
          width: '100%',
          padding: window.innerWidth <= 768 ? '16px' : '24px',
          maxHeight: '100vh',
          overflowY: 'auto',
          overflowX: 'hidden'
        }}
      >
        <div style={{ marginBottom: '12px' }}>
          <Link to="/login" className="back-to-home-btn">
            <span className="back-to-home-icon">←</span>
            Back to sign in
          </Link>
        </div>
        <div className="card auth-screen" style={{ margin: 0 }}>
          <div className="text-center mb-3">
            <img
              src={labLogoUrl || '/logo-labster.jpeg'}
              alt={labLogoUrl ? 'Lab logo' : 'THE LABSTER'}
              style={{
                maxWidth: window.innerWidth <= 768 ? '100px' : '120px',
                width: '100%',
                height: 'auto',
                marginBottom: '12px'
              }}
            />
            <p className="page-subtitle" style={{ marginBottom: '16px' }}>
              Forgot your password?
            </p>
          </div>

          <p style={{ fontSize: '0.875rem', color: 'var(--text-secondary)', marginBottom: '16px' }}>
            Enter the email you use for Labster. If an account exists, we&apos;ll send a link to reset your password.
          </p>

          <form onSubmit={handleSubmit}>
            <div className="form-group" style={{ marginBottom: '16px' }}>
              <label className="form-label" style={{ marginBottom: '6px', fontSize: '0.875rem' }} htmlFor="forgot-email">
                Email
              </label>
              <input
                id="forgot-email"
                type="email"
                className="form-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                style={{ padding: '8px 12px', fontSize: '0.875rem' }}
              />
            </div>
            <button
              type="submit"
              className="btn btn-primary"
              style={{ width: '100%', padding: '10px', fontSize: '0.875rem', marginBottom: '12px' }}
              disabled={loading}
            >
              {loading ? (
                <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
                  <GradientSpinner size={20} />
                  Sending…
                </span>
              ) : (
                'Send reset link'
              )}
            </button>
          </form>

          <div className="text-center" style={{ marginTop: '12px' }}>
            <Link to="/register" style={{ color: '#33FFD9', fontSize: '0.875rem' }}>
              Create an account
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
